module.exports = __webpack_public_path__ + "static/media/lottery5_banner_MHSB999.2ff0afaf.png";